<template>
  <div>

    <v-fade-transition mode="out-in">
      <div 
        v-if="loading" 
        class="is-relative">
        <v-spin-loader :value="true">
          <div class="py-6"></div>
        </v-spin-loader>
      </div>

      <article 
        v-if="!loading && bomDetails.length == 0" 
        class="message is-info is-fullwidth">
        <div class="message-body">
          <span v-if="!product.product_master_id">
            Please select a Product.
          </span>
          <span v-else> 
            No bom details available for this product.
          </span>
        </div>
      </article>
    
      <table
        v-if="!loading && bomDetails.length > 0"
        :key="`${product.product_master_id}-${product.stocking_unit_id}`"
        class="table is-fullwidth is-hoverable is-clickable has-smallish-font">
        <thead>
          <tr>
            <th>
              <v-checkbox
                :value="allSelected"
                @input="toggleAllSelected($event)">
              </v-checkbox>
            </th>
            <th 
              v-for="(header, i) in bomDetailHeaders"
              :key="i">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr 
            class="v-centered"
            v-for="detail in bomDetails"
            :key="detail.id">
            <td>
              <v-checkbox
                :value="selected.indexOf(detail.id) != -1"
                @input="toggleSelected(detail)">
              </v-checkbox>
            </td>
            <td>
              {{ detail.bom.project.project_name }}
            </td>
            <td>
              <router-link 
                :to="{ 
                  name: 'BomViewer', 
                  params: { bomId: detail.bom.id, bom: detail.bom }}">
                {{ detail.bom.name }}
              </router-link>
            </td>
            <td>
              <span v-if="detail.product_master.product_category.has_dimensions">
                L{{ detail.stocking_unit.length_in_str }}" x 
                W{{ detail.stocking_unit.width_in_str }}" x
                T{{ detail.stocking_unit.thick_in_str }}"
              </span>
            </td>
            <td>
              {{ detail.finished_qty }}
            </td>
            <td>
              {{ detail.product_master.unit ? detail.product_master.unit_display_name : null }}
            </td>
          </tr>
        </tbody>
      </table>
    </v-fade-transition>
  </div>
</template>

<script>
import VSpinLoader from '@/components/base/VSpinLoader'
import VFadeTransition from '@/components/transitions/VFadeTransition'
import VCheckbox from '@/components/base/VCheckbox'

export default {
  props: {
    product: {
      type: Object
    }
  },
  components: {
    VSpinLoader,
    VFadeTransition,
    VCheckbox
  },
  data() {
    return {
      loading: false,
      bomDetails: [],
      selected: [],
      allSelected: false,
      bomDetailHeaders: [
        'Project', 'BOM', 'Size', 'Qty', 'Unit'
      ]
    }
  },
  computed: {
    selectedDetails() {
      return this.bomDetails.filter(d => 
        this.selected.indexOf(d.id) != -1
      )
    }
  },
  watch: {
    product: {
      handler(product) {
        this.getBomDetails(product);
      },
      deep: true
    }
  },
  methods: {
    getBomDetails(product) {
      this.loading = true;

      this.$http.bomDetails.get({
        product_master_id: product.product_master_id,
        stocking_unit_id: product.stocking_unit_id,
        only_unassigned: true
      }).then(resp => {
        this.bomDetails = resp.data.results;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
    toggleSelected(detail) {
      const index = this.selected.indexOf(detail.id);
      if (index == -1) {
        this.select(detail);
      } else {
        this.deselect(detail.id);
      }
    },
    select(detail) {
      this.selected.push(detail.id);
      this.$emit('select', detail);
    },
    deselect(id) {
      this.$emit('deselect', id);

      let index = this.selected.indexOf(id);
      this.selected.splice(index, 1);
      if (this.selected.length == 0) {
        this.allSelected = false;
      }
    },
    toggleAllSelected(v) {
      this.allSelected = v;
      const { selected } = this;

      if (v) {
        this.bomDetails.forEach(detail => {
          if (!selected.includes(detail.id)) {
            this.select(detail);
          }
        })
      } else {
        this.bomDetails.forEach(detail => {
          if (selected.includes(detail.id)) {
            this.deselect(detail.id);
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';

.justify-space-between {
  justify-content: space-between;
}
</style>